import React from "react";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import Spacing from "../Spacing";
import { Helmet } from "react-helmet";

export default function MercuryMicro() {
  pageTitle("MercuryMini Details");
  return (
    <>
      <Helmet>
        <title>
          Mercury Micro – Compact Hypothermia Unit | Mercury Healthcare |
          Manufacturer & Supplier
        </title>

        <meta
          name="description"
          content="Mercury Micro is a compact hypothermia unit with touch control, PLC-based electronics, a 3L closed tank, and a 5L/min flow rate. Ideal for precision cooling."

        />
        {/* Google Tag (gtag.js) */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-MGF4V7P4YB"></script>
        <script>
          {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-MGF4V7P4YB');
      `}
        </script>
      </Helmet>

      <Section topMd={170} topLg={145} topXl={90} bottomLg={90}>
        <div className="cs_doctor_details">
          <div className="cs_doctor_details_bg cs_bg_filed" />
          <Spacing md="85" />
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="cs_single_doctor overflow-hidden cs_radius_20 p-5">
                  <img
                    src="/images/MercuryMicro/Mercury Micro (1).png"
                    alt="Doctor"
                    className="w-100 cs_radius_20 "
                  />
                  <h3
                    className="cs_white_color cs_accent_bg mb-0 text-center cs_semibold cs_fs_24"
                    style={{
                      padding: "14px 15px",
                    }}
                  >
                    Mercury Micro
                  </h3>
                </div>
              </div>
              <div className="col-lg-6   position-relative">
                <Spacing md="55" />
                <h1
                  className="cs_fs_120 mb-0 cs_semibold"
                  style={{
                    fontSize: "45px",
                    color: "#3f48cc",
                  }}
                >
                  {" "}
                  Mercury Micro-Portable ECMO Heater
                </h1>

                <Spacing md="32" />
                <p className="mb-0 cs_heading_color">
                Mercury Micro is Portable Heater Unit. Micro is used to
maintain the blood temperature through conductive
heat transfer. The conductive heat transfer is
accomplished through blood oxygenator/heat
exchanger unit. The user regulates the desired fluid
temperature with continuous monitoring
                </p>

                {/* <Spacing md="32" /> */}
                <h4 className="underline"> Applications</h4>
                <p
                  style={{
                    color: "#274760",
                  }}
                >
                  {" "}
                  The Mercury Micro can be used for the Extracorporeal
                  Membrane Oxygenation (ECMO) surgeries.
                </p>
                {/* <Section topMd={70} topLg={45} topXl={20} bottomLg={90}>
                  <div className="container">
                    <div className="img-details-container">
                      {/* Left Section: Features and Product Images  
                      <div className="left-section">
                      
                        <div className="featureList">
                          <h3
                            className="underline"
                            style={{
                              color: "#3f48cc",
                            }}
                          >
                            {" "}
                            Features
                          </h3>
                          <div className="listdata">
                            <ul>
                              <li>
                                <strong> Touch Control Display </strong>
                              </li>
                              <li>
                                <strong> PLC based electronics</strong>
                              </li>
                              <li>
                                <strong> Unit operates on 230V / 50Hz </strong>
                              </li>
                              <li>
                                <strong>YSI 400 type temp port </strong>
                              </li>
                              <li>
                                <strong>
                                  Closed tank unit with 3Lit water capacity
                                </strong>
                              </li>
                              <li>
                                <strong> Single Out put circuit </strong>
                              </li>
                              <li>
                                <strong> Flow rate 5lit / min </strong>
                              </li>
                              <li>
                                <strong> Apprx 12kg weight</strong>
                              </li>
                              <li>
                                <strong> L 38 x H 25.5 x W19.5 cms</strong>
                              </li>
                            
                            </ul>
                          </div>
                        </div>

                    
                      </div>

                       


              
                    </div>
                  </div>
                </Section> */}
              </div>
            </div>
          </div>
        </div>
      </Section>

      <Section topMd={170} topLg={145} topXl={90} bottomLg={90}>
        <div className="container">
          <div className="img-details-container">
           
            <div className="left-section">
               
 
              <div className="featureList">
                <h3
                  className="underline"
                  style={{
                    color: "#3f48cc",
                  }}
                >
                  {" "}
                  Features
                </h3>
                <div className="listdata">
                  <ul>
                     
                    <li>
                      <strong>
                      Fastest Heating in it's Class:
                      </strong>
                      It has 3 Litre water tank with 500 W heaters to achieve desired set point quickly.
                    </li>
                    <li>
                      <strong> Graphical User Interface:  </strong>Visual & easy to use graphical interface for water flow & temperature.


                    </li>
                    <li>
                      <strong>Fully Touch Controller Display:  </strong> All parameter can be controlled on finger touch.
                    </li>
                    <li>
                      <strong>Robust Design:</strong> Robust design including PLC based electronics to avoid periodic repairs.


                    </li>
                    <li>
                      <strong>  Single Output Circuits: </strong> It can be used to support single patient.
                    </li>
                   
                    
                  </ul>
                </div>
              </div>
  
             
            </div>
 
          </div>
        </div>
      </Section>

      <Section topMd={170} topLg={145} topXl={90} bottomLg={90}>
        <div className="container">
          <h3 className="underline">Specifications</h3>
          <div className="specification">
            <div className="leftside-specification">
              <div>
                <h4>Dimensions:</h4>
                <ul>
                  <li> Height: 10.03" (25.5 cm)</li>
                  <li>Width: 7.67" (19.5 cm)
</li>
                  <li>Length: 14.96" (38 cm)</li>
                  <li>Weight: 26.45 lbs. (12kg) </li>
                </ul>
              </div>
              <div>
                <h4> Power Supply: </h4>
                <ul>
                  <li> Voltage: 230 VAC, 1 Phase </li>
                  <li> Frequency: 50Hz </li>
                  <li> Current: 6A </li>
                  <li> Leakage Current: 500mA max </li>
                </ul>
              </div>
            </div>
            <div className="rightside-specification">
              <div>
                <h4> Water Tank: </h4>
                <ul>
                  <li>Capacity: 3 Liter (0.79 Gal), Single tank</li>
                  <li>Temperature Range: 35-42°C (95-107°F)</li>
                </ul>
              </div>

              <div>
                <h4> Heater</h4>
                <ul>
                  <li>Heaters: 01 Numbers </li>
                  <li>Heater wattage: 500 watt
                  </li>
                </ul>
              </div>
              <div>
                <h4>Output Ports: </h4>
                <ul>
                  <li>Flow: 5 ltr/min
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <Spacing md="32" />
        </div>
      </Section>
    </>
  );
}
